import { render, staticRenderFns } from "./JoinedCard.vue?vue&type=template&id=e1d5a5a2&scoped=true"
import script from "./JoinedCard.vue?vue&type=script&lang=js"
export * from "./JoinedCard.vue?vue&type=script&lang=js"
import style0 from "./JoinedCard.vue?vue&type=style&index=0&id=e1d5a5a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d5a5a2",
  null
  
)

export default component.exports